import { createContainer } from "unstated-next";
import { useState } from "react";
const PostPageViewModeContext = createContainer((initialState = "VIEW")=>{
    return useState(initialState);
});
export const usePostPageViewMode = PostPageViewModeContext.useContainer;
export const PostPageViewModeProvider = PostPageViewModeContext.Provider;
